import Container from "../container/Container";
import NetworkCard from "./NetworkCard";
import ServiceCard from "./ServiceCard";
import ServiceHeader from "./ServiceHeader";
import ServiceNetwork from "./ServiceNetwork";
import Team from "./Team";
import TeamsCard from "./TeamsCard";

const Service = () => {
  return (
    <section className="bg-gray-50 min-h-screen">
      <Container>
        <div className="px-3 py-5">
          <ServiceHeader />
          <ServiceCard />
          <ServiceNetwork />
          <NetworkCard />
          <Team />
          <TeamsCard />
        </div>
      </Container>
    </section>
  );
};

export default Service;
